
// A $( document ).ready() block.
$( document ).ready(function() {
    $(".member-cell").on("click", function(e) {
        var id = $(this).data("id");
        var reveal_row = $(".details-row[data-id="+id+"]");
        if ($(reveal_row).is(":visible")) {
            $(reveal_row).addClass('hidden');
        }
        else {
            $(reveal_row).removeClass('hidden');
        }

    });
});
